import C from '@/utils/rule/constant'
import BaseCalculator from "./BaseCalculator"

class JPWomanHipSkirt extends BaseCalculator {

    /**
     * 胸腰差比
     * @type {number}
     */
    ratio_xy = 0
    /**
     * 胸臀差
     * @type {number}
     */
    ratio_xt = 0

    body = {
        [C.B_TTT_HT] : {
            '瘦臀' : -1,
            '正常' : 0,
            '丰臀' : 1,
        },
    }

    /**
     * 成衣参数key和计算公式
     * @type {{[p: string]: function(*, *, *): *}}
     * 匹配正则 ((base)|(net)|(plus))\[C\.(C|N)([A-Z_])*\]
     */
    complete_size = {
        [C.SOMATOTYPE_A] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            }
        },
        [C.SOMATOTYPE_B] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            }
        },
        [C.SOMATOTYPE_C] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            }
        },
        [C.SOMATOTYPE_D] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            }
        },
        [C.SOMATOTYPE_Y] : {
            [C.PREFERENCE_FITTED] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_NORMAL] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            },
            [C.PREFERENCE_LOOSE] : {
                [C.C_QC_SL] : function (net, base, plus) {
                    return 50 + (parseFloat(net[C.N_KC_TL]) - 100) / 2
                },
                [C.C_YW_WL] : function (net, base, plus) {
                    return parseFloat(net[C.N_KYW_TWL]) + parseFloat(base[C.C_YW_WL]) + parseFloat(plus[C.C_YW_WL])
                },
                [C.C_TW_HL] : function (net, base, plus) {
                    return parseFloat(net[C.N_TW_HL]) + parseFloat(base[C.C_TW_HL]) + parseFloat(plus[C.C_TW_HL])
                }
            }
        },
    }


    /**
     * 覆盖父类方法
     * @param size
     */
    setNetSize(size) {
        super.setNetSize(size)
        // 计算胸腰差比
        this.ratio_xy = (parseFloat(this.net_size[C.N_ZYW_MWL]) / this.net_size[C.N_XW_CL] - 1) * 100
        this.ratio_xt = this.net_size[C.N_XW_CL] - this.net_size[C.N_TW_HL]
    }

    /**
     * 穿衣偏好的加放基础值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    base(somatotype, preference) {
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  0,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  0,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  0,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  0,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  0,
                    [C.C_TW_HL] :  0,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  1,
                    [C.C_TW_HL] :  0,
                }
            }
        }

        return data[somatotype][preference]
    }

    /**
     * 加放量值
     * @param somatotype
     * @param preference
     * @returns {*}
     */
    plus(somatotype, preference) {
        let data =  {
            [C.SOMATOTYPE_A] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - 1.25,
                    [C.C_TW_HL] :  2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :   (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - 1.25,
                    [C.C_TW_HL] :  3.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :   (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - 1.25,
                    [C.C_TW_HL] :  5,
                }
            },
            [C.SOMATOTYPE_B] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .75,
                    [C.C_TW_HL] :  2.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .75,
                    [C.C_TW_HL] :  3.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .75,
                    [C.C_TW_HL] :  5,
                }
            },
            [C.SOMATOTYPE_C] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .25,
                    [C.C_TW_HL] :  2,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .25,
                    [C.C_TW_HL] :  3,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 - .25,
                    [C.C_TW_HL] :  5,
                }
            },
            [C.SOMATOTYPE_D] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2,
                    [C.C_TW_HL] :  2,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2,
                    [C.C_TW_HL] :  3,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :   (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2,
                    [C.C_TW_HL] :  5,
                }
            },
            [C.SOMATOTYPE_Y] : {
                [C.PREFERENCE_FITTED] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 + .25,
                    [C.C_TW_HL] :  3.5,
                },
                [C.PREFERENCE_NORMAL] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 + .25,
                    [C.C_TW_HL] :  4.5,
                },
                [C.PREFERENCE_LOOSE] : {
                    [C.C_QC_SL] : 0,
                    [C.C_YW_WL] :  (parseFloat(this.net_size[C.N_ZYW_MWL]) - parseFloat(this.net_size[C.N_KYW_TWL])) / 2 + .25,
                    [C.C_TW_HL] :  6,
                }
            }
        }

        return data[somatotype][preference]
    }


    /**
     * 计算成衣尺寸
     * @param preference
     * @returns {{}}
     */
    getCompleteSize(preference) {
        this.preference = preference
        let somatotype = this.custom_somatotype || this.default_somatotype
        let base_size = this.base(somatotype , this.preference)
        let plus_size = this.plus(somatotype, this.preference)
        let formulas = this.complete_size[somatotype][this.preference];

        let result = {}
        for(let key in formulas) {
            let temp = Math.round(formulas[key].apply(this, [this.net_size, base_size, plus_size]) * 10) / 10
            result[key] = isNaN(temp) ? 0 : temp
        }

        console.log(plus_size)
        return result
    }

    getBodySize() {
        let result = {}
        for(let key in this.body_size) {
            if (key in this.body) result[key] = this.body[key][this.body_size[key]] || 0

        }

        return result
    }
}

export default JPWomanHipSkirt
